import LossesAnalyticsByIngredient from './ByIngredient';

const LossesAnalyticsModule = {
  LossesAnalyticsByIngredient,
};

export default LossesAnalyticsModule;
